module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "fluid"
  }, [_c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "persistent": ""
    },
    model: {
      value: (_vm.dialogAdicionar),
      callback: function($$v) {
        _vm.dialogAdicionar = $$v
      },
      expression: "dialogAdicionar"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "headline grey lighten-4"
  }, [_vm._v("\n        Registrar Envio de Relatório do Projeto\n      ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('v-text-field', {
    attrs: {
      "label": "Id do Projeto",
      "type": "number",
      "outlined": "",
      "dense": "",
      "required": "",
      "disabled": ""
    },
    model: {
      value: (_vm.idProjetoDigitado),
      callback: function($$v) {
        _vm.idProjetoDigitado = $$v
      },
      expression: "idProjetoDigitado"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Data final do período",
      "type": "date",
      "outlined": "",
      "dense": "",
      "required": ""
    },
    model: {
      value: (_vm.novoRegistro.dtEnvio),
      callback: function($$v) {
        _vm.$set(_vm.novoRegistro, "dtEnvio", $$v)
      },
      expression: "novoRegistro.dtEnvio"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Número do relatório",
      "type": "number",
      "outlined": "",
      "dense": "",
      "required": ""
    },
    model: {
      value: (_vm.novoRegistro.numRelatorio),
      callback: function($$v) {
        _vm.$set(_vm.novoRegistro, "numRelatorio", $$v)
      },
      expression: "novoRegistro.numRelatorio"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Número do Processo",
      "outlined": "",
      "dense": "",
      "required": ""
    },
    model: {
      value: (_vm.novoRegistro.numProcesso),
      callback: function($$v) {
        _vm.$set(_vm.novoRegistro, "numProcesso", $$v)
      },
      expression: "novoRegistro.numProcesso"
    }
  }), _vm._v(" "), _c('v-select', {
    attrs: {
      "label": "Nova Situação do Projeto",
      "items": _vm.listaSituacoesPossiveis,
      "item-text": "descricao",
      "item-value": "item",
      "max-height": "400",
      "return-object": "",
      "required": ""
    },
    model: {
      value: (_vm.novoRegistro.situacao),
      callback: function($$v) {
        _vm.$set(_vm.novoRegistro, "situacao", $$v)
      },
      expression: "novoRegistro.situacao"
    }
  })], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', {
    staticClass: "justify-end"
  }, [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function($event) {
        _vm.dialogAdicionar = false
      }
    }
  }, [_vm._v("Cancelar")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary",
      "dark": "",
      "disabled": !_vm.novoRegistro.dtEnvio || !_vm.novoRegistro.numRelatorio || !_vm.novoRegistro.numProcesso || !_vm.novoRegistro.situacao
    },
    on: {
      "click": _vm.registrarEnvio
    }
  }, [_vm._v("\n          Salvar\n        ")])], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs10": ""
    }
  }, [_c('v-card', {
    staticClass: "text-xs-center"
  }, [_c('basic-toolbar', {
    attrs: {
      "title": 'Registros de Envio de Relatório de Projeto'
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "ID do Projeto",
      "type": "number",
      "outlined": ""
    },
    model: {
      value: (_vm.idProjetoDigitado),
      callback: function($$v) {
        _vm.idProjetoDigitado = $$v
      },
      expression: "idProjetoDigitado"
    }
  })], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-btn', {
    staticClass: "mt-4",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.buscarRegistros
    }
  }, [_vm._v("\n                Buscar Registros\n              ")])], 1), _vm._v(" "), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-btn', {
    staticClass: "mt-4",
    attrs: {
      "color": "success",
      "disabled": !_vm.idProjetoDigitado || _vm.idProjetoDigitado != _vm.idProjetoBuscado
    },
    on: {
      "click": _vm.abrirDialogAdicionar
    }
  }, [_vm._v("\n                Adicionar Registro\n              ")])], 1)], 1), _vm._v(" "), _c('v-data-table', {
    attrs: {
      "headers": _vm.headers,
      "items": _vm.listaRegistros,
      "no-data-text": 'Nenhum registro encontrado'
    },
    scopedSlots: _vm._u([{
      key: "item.dtEnvio",
      fn: function(ref) {
        var item = ref.item;

        return [_vm._v("\n              " + _vm._s(_vm.formatarData(item.dtEnvio)) + "\n            ")]
      }
    }, {
      key: "item.acoes",
      fn: function(ref) {
        var item = ref.item;

        return [_c('v-btn', {
          attrs: {
            "icon": "",
            "small": "",
            "color": "primary",
            "disabled": _vm.idProjetoDigitado != _vm.idProjetoBuscado
          },
          on: {
            "click": function($event) {
              return _vm.editarRegistro(item)
            }
          }
        }, [_c('v-icon', [_vm._v("edit")])], 1), _vm._v(" "), _c('v-btn', {
          attrs: {
            "icon": "",
            "small": "",
            "color": "red",
            "disabled": _vm.idProjetoDigitado != _vm.idProjetoBuscado
          },
          on: {
            "click": function($event) {
              return _vm.excluirRegistro(item)
            }
          }
        }, [_c('v-icon', [_vm._v("delete")])], 1)]
      }
    }])
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f5c5912","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/administracao/registro-envio-relatorios-projeto.vue
// module id = 738
// module chunks = 0